export const getPermissionState = (state: any) => state.permission;
